import React from "react"
import { SumTable, calcIncomeSum, calcTotalIncome, IncomeDetails } from "../Tree/Utils.js"

// not used here - required by others
export const  Balance_microLegend = {
    "total_expenses": "סך ההוצאות על דיור (כולל משכנתא)",
    "total_education": "סך ההוצאות על חינוך",
    "total_shotef": "סך הוצאות שוטפות",
    "total_debts_return": "סכום החזר חובות חודשי",
    "total_family_expenses": "סה''כ הוצאות משפחתיות",
    "total_family_balance": "פער בין הכנסות להוצאות",
    "balance_comment": "הערות"
}

export class FamilyBalance extends React.PureComponent {

    render() {
      const { tableTitle, cpt } = this.props
      var expenses = calcIncomeSum(cpt['family_expenses'],'expense_sum'),
          debts    = calcIncomeSum(cpt['family_debts'],'family_debt_monthlyreturn'),
          mort     = calcIncomeSum(cpt['family_mortgage'],'mortgage_monthly'),
          income   = calcTotalIncome(cpt['family_income'],'income_sum','income_frequency'),
          savings  = parseInt(cpt['family_savings']['monthly_savings_avg'])
      const balance = parseInt(income) - (parseInt(expenses)+parseInt(debts)+parseInt(mort)+parseInt(savings))
      const debts_percent = debts > 0 ? Math.round(debts/income*100) : 0
      const mort_percent = mort > 0 ? Math.round(mort/income*100) : 0
      const total_expenses = debts + mort + expenses + savings
      let diffColor = (value) => value < 0 ? {color:'red'} : {color:'green'}
      
      return (
        <div className="yahav-modal balance">
            <h2 style={{textAlign: 'right'}}>{tableTitle}</h2>
            
            <div className="table-total">
              <span className="table-total-title">פער הכנסות מול הוצאות: </span>
              <span className="table-sum" style={diffColor(balance)}>{balance.toLocaleString('he-IL')}</span>
            </div>
            <div className="table-total">
              <span className="table-total-title">סה"כ הכנסות חודשי </span>
              <span className="table-sum" style={diffColor(income)}>{income.toLocaleString('he-IL')}</span>
            </div>
            <IncomeDetails products={cpt['family_income']} />
            {/*<ul className="sub-sum">
              <li>
                <SumTable2 className="sub-sum" products={cpt['family_income']} field={'income_sum'} class={"work"} title={'הכנסות מעבודה'} />
              </li>
              <li>
                <SumTable2 className="sub-sum" products={cpt['family_income']} field={'income_sum'} class={"rights"} title={'הכנסות מזכויות'} />
              </li>
              <li>
                <SumTable2 className="sub-sum" products={cpt['family_income']} field={'income_sum'} class={"capital"} title={'הכנסות מהון'} />
              </li>

      </ul>*/}
            <div className="table-total">
              <span className="table-total-title">סה"כ הוצאות והחזרים </span>
              <span className="table-sum">{total_expenses.toLocaleString('he-IL')}</span>
            </div>
            <ul className="sub-sum">
              <li>
                <SumTable className="sub-sum" products={cpt['family_expenses']} field={'expense_sum'} title={'סה"כ הוצאות חודשי'} />
              </li>
              <li>
                <SumTable className="sub-sum" products={cpt['family_debts']} field={'family_debt_monthlyreturn'} title={'החזר חובות חודשי'} />
                { debts <= 0 ? null : income <= 0 ? <span className="table-total">אין הכנסות!</span> :
                  debts_percent > 0 ? <span className="table-total">&nbsp;({debts_percent}% מההכנסות)</span> : null}
              </li>
              <li>
                <SumTable className="sub-sum" products={cpt['family_mortgage']} field={'mortgage_monthly'} title={'משכנתאות החזר חודשי'} />
                { mort <= 0 ? null : income <= 0 ? <span className="table-total">אין הכנסות!</span> : 
                  mort_percent > 0 ? <span className="table-total">&nbsp;({mort_percent}% מההכנסות)</span> : null}
              </li>
              <li>
                <div className="table-total">
                  <span className="table-total-title">חסכון לילדים </span>
                  <span className="table-sum">{savings.toLocaleString('he-IL')}</span>
                </div>
              </li>
            </ul>

            <ul className="info-comments" style={{marginTop:'3em'}}>
              <li>הערך NaN מסמן חסר בנתונים. לדוגמא: שדה תדירות שלא מוגדר בהכנסות.</li>
              <li>הנתונים נלקחים מלשונית בנתוני המשפחה</li>
              <li>מענקים חד פעמיים לא נכללים<br />
                הערה: הכנסה "חד פעמית" שצריכה להופיע במאזן חודשי - אינה חד פעמית. כדאי לשקול שינוי הגדרה.
              </li>
              <li>הכנסה רבעונית או שנתית תחושב בחלק היחסי</li>
              <li>כל הערכים "מעוגלים" למספרים שלמים ללא נקודה עשרונית</li>
              <li>עדיין לא נכללים יתרונות מטבלת מיצוי זכויות!!!</li>
            </ul>
        </div>
      )
    }
  }

 